import React from 'react';
import {Link,useHistory} from 'react-router-dom'


function Navbar() {
  const history =  useHistory("")
  const user = JSON.parse(localStorage.getItem("user"))
  const renderList = ()=>{
  
    if(user){
      return[
        <li><Link to="/profile" key={"1"} >Profile</Link></li>,
        <li><Link to="/create" key={"2"} >Create post</Link></li>,
        <button key={"3"}className="btn waves-effect waves-light" 
        onClick={()=>{
          localStorage.clear()
          history.push('/signin')
          window.location.reload(false);
      }
        }><i className="material-icons" style={{height:"10px",width:"10px",marginTop:"-30px",marginLeft:"-12px"}}>settings_power</i>
        </button>
      ]
    }
      else{
        return[
          <li><Link to="/signin" key={"4"}>Signin</Link></li>,
          <li><Link to="/signup" key={"5"}>Signup</Link></li>
        ]
      }
    }
  
  return (
    <nav>
    <div className="nav-wrapper white" >
      <Link to={user?"/":"/signin"} className="brand-logo left" style={{marginLeft:"25px"}}>Minsta</Link>
      <ul id="nav-mobile" className="right" style={{marginRight:"20px"}}>
          {renderList()}

      </ul>
    </div>
  </nav>
  );
}

export default Navbar;
